import { CarTireAlertIcon } from './CarTireAlertIcon';

/**
 * author: Michael Irigoyen
 * id 93700192-0A90-4FC4-944C-894F29BB478F
 * name car-tire-alert
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-tire-alert.svg
 * tags
 * - Automotive 
 * - Alert / Error 
 */
export const CarTyreAlertIcon = CarTireAlertIcon;
export default CarTyreAlertIcon